import React, { useEffect, useRef } from "react";
import { Instagram } from "lucide-react";

export const InstagramReelsSection = () => {
  const containerRef = useRef(null);

  const reels = [
    {
      id: "DShtBw4AUUR",
      url: "https://www.instagram.com/reel/DShtBw4AUUR/",
    },
    {
      id: "DSM7d-fAEbk",
      url: "https://www.instagram.com/reel/DSM7d-fAEbk/",
    },
    {
      id: "DQbI23HDXdU",
      url: "https://www.instagram.com/reel/DQbI23HDXdU/",
    },
    {
      id: "DPjDxuNjeia",
      url: "https://www.instagram.com/reel/DPjDxuNjeia/",
    },
    {
      id: "DO8NDGzgXRG",
      url: "https://www.instagram.com/reel/DO8NDGzgXRG/",
    },
    {
      id: "DSfHWUqiFTb",
      url: "https://www.instagram.com/reel/DSfHWUqiFTb/",
    },
    {
      id: "DQVr2xyDCJE",
      url: "https://www.instagram.com/reel/DQVr2xyDCJE/",
    },
    {
      id: "DRR0wERCQIG",
      url: "https://www.instagram.com/reel/DRR0wERCQIG/",
    },
    {
      id: "DPnoAMLDACC",
      url: "https://www.instagram.com/reel/DPnoAMLDACC/",
    },
  ];

  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    // Initialize embeds after script loads
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  // Re-process embeds when component updates
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  });

  return (
    <section className="py-20 px-6 lg:px-8 bg-gradient-to-b from-purple-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Instagram className="w-8 h-8 text-purple-600" />
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              See Us in Action
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Watch real moments from our training sessions, student performances,
            and behind-the-scenes content
          </p>
        </div>

        {/* Reels Grid */}
        <div
          ref={containerRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"
        >
          {reels.map((reel) => (
            <div
              key={reel.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Instagram Embed - Using blockquote for proper embed */}
              <blockquote
                className="instagram-media"
                data-instgrm-permalink={reel.url}
                data-instgrm-version="14"
                style={{
                  background: "#FFF",
                  border: "0",
                  borderRadius: "1rem",
                  margin: "0",
                  maxWidth: "100%",
                  minWidth: "100%",
                  padding: "0",
                  width: "100%",
                }}
              ></blockquote>
            </div>
          ))}
        </div>

        {/* Follow CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://www.instagram.com/barryjohnsfreebirds/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-semibold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <Instagram className="w-5 h-5" />
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};
